import React from "react";
import moment from "moment";
import TypingDots from "../Footer/TypingDots";
import { RiAttachment2 } from "react-icons/ri";
import { stripMarkdown } from "../../utils/sse";
import MarkdownRenderer from "./MarkdownRenderer";

export const Message = ({ messageItem }) => {
  const isUser = messageItem.from === "user";

  return (
    <div
      className={[
        "w-fit max-w-[85%] min-w-0 rounded-2xl px-3 py-2",
        "flex flex-col gap-0.5 overflow-hidden",
        isUser ? "bg-grayTrue700 ml-auto" : "bg-grayTrue800",
      ].join(" ")}
    >
      <div className="text-base break-words text-white min-w-0">
        {messageItem.pending ? (
          <TypingDots />
        ) : isUser ? (
          messageItem.message
        ) : (
          <MarkdownRenderer>
            {stripMarkdown(messageItem.message)}
          </MarkdownRenderer>
        )}
      </div>
      {!messageItem.pending && (
        <div className="flex w-fit items-center gap-1">
          {messageItem.attachedFilesLength ? (
            <RiAttachment2 className="text-grayTrue400 size-3" />
          ) : null}
          <div
            className={[
              "text-grayTrue400 w-fit text-xs text-nowrap",
              isUser ? "ml-auto" : "",
            ].join(" ")}
          >
            {moment(messageItem.timestamp).format("MM/DD/YYYY, HH:mm:ss")}
          </div>
        </div>
      )}
    </div>
  );
};
